module.exports = __webpack_public_path__ + "img/icon-person-white.ba03aa63.svg";